var render = function render(){var _vm=this,_c=_vm._self._c;return _c('image-cell',{attrs:{"content":_vm.url,"attribute":_vm.attribute}})
}
var staticRenderFns = []

export { render, staticRenderFns }